import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const TimeSeriesChart = ({ data }) => {
  // Transform data for Recharts format
  const chartData = data.map((item) => {
    const dataPoint = { date: item._id };

    item.events.forEach((event) => {
      dataPoint[event.type] = event.count;
    });

    return dataPoint;
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Aktivität im Zeitverlauf</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              style={{ fontSize: '12px' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis style={{ fontSize: '12px' }} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="page_view"
              stroke="#3b82f6"
              name="Profilaufrufe"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="link_click"
              stroke="#d90000"
              name="Link-Klicks"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="profile_download"
              stroke="#8b5cf6"
              name="Downloads"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="qr_view"
              stroke="#f59e0b"
              name="QR-Aufrufe"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default TimeSeriesChart;
